module finadai.app.customers {
  export var NAME = "finadai.app.customers";
  function ConfigRoutes($stateProvider: ng.ui.IStateProvider){
    $stateProvider.state('app.customers', {
			templateUrl: 'app/customers/customers.tpl.html',
			url: '/customers',
		})
    .state('app.customers.detail', {
      templateUrl: 'app/customers/detail/detail.tpl.html',
      url: '/detail/:customerCode',
      controller: 'CustomerDetailController',
      resolve: {
        customer: (customersService: services.CustomersService, $stateParams) => {
          return customersService.get($stateParams.customerCode);
        }
      }
    })
    .state('app.customers.profile', {
      templateUrl: 'app/customers/detail/detail.tpl.html',
      url: '/profile',
      controller: 'CustomerDetailController',
      resolve: {
        customer: (customersService: services.CustomersService, whoIAm: models.User) => customersService.proxyGetCustomer({ customer_number: whoIAm.customer_number}),
        negotiation: (customersService: services.CustomersService, whoIAm: models.User) => customersService.proxyGetNegotiation({ customer_number: whoIAm.customer_number}),
        creditInfo: (customersService: services.CustomersService, whoIAm: models.User) => customersService.proxySearchCredit({ customer_number: whoIAm.customer_number})
      }
    })
    .state('app.customers.cancel_negotiation', {
      templateUrl: 'app/customers/cancel_negotiation.tpl.html',
      url: '/cancel_negotiation',
      controller: 'CustomerCancelNegotiationController',
      resolve: {
        customer: (customersService: services.CustomersService, whoIAm: models.User) => customersService.proxyGetCustomer({ customer_number: whoIAm.customer_number}),
        negotiation: (customersService: services.CustomersService, whoIAm: models.User) => customersService.proxyGetNegotiation({ customer_number: whoIAm.customer_number}),
        creditInfo: (customersService: services.CustomersService, whoIAm: models.User) => customersService.proxySearchCredit({ customer_number: whoIAm.customer_number})
      }
    })
    .state('app.customers.timeline', {
      templateUrl: 'app/customers/timeline/timeline.tpl.html',
      url: '/timeline/:customerNumber',
      controller: 'CustomerTimelineController',
      resolve: {
        customer: (customersService: services.CustomersService, $stateParams) => {
          if($stateParams.customerNumber){
            return customersService.get($stateParams.customerNumber, true);
          }
          // return customersService.getInfo();
        }
      }
    });
  }
  export function run(){
    var customers = angular.module(NAME, [
      finadai.app.customers.detail.NAME,
      finadai.app.customers.timeline.NAME
    ]);
    customers.config(ConfigRoutes);
  }
}
finadai.app.customers.run();